<template>
    <div class="login-container">
        <form class="login-modal" @submit.prevent="handleSubmit">
            <h2>登录</h2>
            <div>
                <label for="username">用户名:</label>
                <input type="text" id="username" v-model="username" required />
            </div>
            <div>
                <label for="password">密码:</label>
                <input type="password" id="password" v-model="password" required />
            </div>
            <button type="submit" class="submit-button">提交</button>
        </form>
    </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { login } from "@/utils/api.js";


export default {
    name: 'Login',
    /*  "username": "18605103153",
  "password": "123456",
  "systype": "hs" */
    setup() {
        const username = ref('');
        const password = ref('');
        const router = useRouter();

        const handleSubmit = async () => {
            try {
                const response = await login({
                    username: username.value,
                    password: password.value,
                    systype: "hs"
                });
                console.log('response:',);

                const { code, msg, token } = response;
                if (code === 200) {
                    localStorage.setItem('token', token);
                    router.push({ name: '首页' });
                }

            } catch (error) {
                console.error('登录失败:', error);
                alert(error.msg);
            } finally {
                closeModal();
            }

        };

        const isModalOpen = ref(false);
        const openModal = () => {
            isModalOpen.value = true;
        };
        const closeModal = () => {
            isModalOpen.value = false;
        };

        return {
            isModalOpen,
            username,
            password,
            openModal,
            closeModal,
            handleSubmit
        };
    }
};
</script>

<style scoped>
.login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    background: url(../assets/BGa.png) no-repeat center center / 100% 100%;
}

.login-button {
    padding: 10px 20px;
    font-size: 16px;
    cursor: pointer;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
}

.login-button:hover {
    background-color: #0056b3;
}

.login-modal {
    background-color: white;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 2px 2px 20px #00000050;
    width: 300px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 1000;
}

.close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: transparent;
    border: none;
    font-size: 18px;
    cursor: pointer;
}

.close-button:hover {
    color: red;
}

form div {
    margin-bottom: 15px;
    width: 100%;
}

label {
    display: block;
    margin-bottom: 5px;
    text-align: left;
}

input {
    width: 100%;
    padding: 8px;
    box-sizing: border-box;
}

.submit-button {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    cursor: pointer;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    margin-top: 10px;
}

.submit-button:hover {
    background-color: #0056b3;
}

.modal-overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
}
</style>
